import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-driver-emm-list',
  templateUrl: './driver-emm-list.component.html',
  styleUrls: ['./driver-emm-list.component.css'],
})
export class DriverEmmListComponent {
  url: string = 'configs';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = 'driverEmm';

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Distance',
      route: '/logistics/fees',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Volume',
      route: '/logistics/fees/volume',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Weight',
      route: '/logistics/fees/weight',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      //desc: 'T2D Charges',
      desc: 'Runner',
      route: '/logistics/fees/task',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'Surcharges',
      route: '/logistics/fees/surcharges',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'EMM',
      route: '/logistics/fees/emm',
    },
  ];

  resumenCardsTwo = [
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        //console.log('response', response);
        //this.data = response.data;
        this.data = response.data.sort((a, b) => {
          return (
            new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          );
        });
        this.filteredData = [...this.data];
        this.updateSuggestions();
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  filterTask() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return item.name && item.name.toLowerCase().includes(texto);
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.name) sugerenciasSet.add(item.name);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }
}
